import styled from 'styled-components';
import { VCheckboxField, VNumericField, VRadioGroupField } from 'welltrax-ui-components';
import { Icon } from '@blueprintjs/core';

interface IStyledGroupFieldFloatRight {
  marginRight?: string;
}

export const StyledGroupFieldFloatRight = styled(VRadioGroupField)`
  & .gsi-input-and-error-container {
    & > div {
      display: flex;
      & > label {
        margin-right: ${(props: IStyledGroupFieldFloatRight) => (props.marginRight ? props.marginRight : `15px`)};
      }
    }
  }
`;

export const StyledCheckBoxLeft = styled(VCheckboxField)`
  & .bp3-form-content label.field-label {
    padding-left: 30px !important;
  }
`;

export const StyledNumericFieldNoButtons = styled(VNumericField)`
  & button {
    display: none;
  }
  & input {
    border-radius: 3px !important;
  }
`;

export const ToggleUpDownBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

interface IToggleIconStyle {
  disabled?: boolean;
  disabledColor?: string;
}

export const ToggleIconStyle = styled(Icon)`
  cursor: ${(props: IToggleIconStyle) => (props.disabled ? 'default' : 'pointer')};
  pointer-events: ${(props: IToggleIconStyle) => props.disabled && 'none'};
  & > svg:not([fill]) {
    fill: ${(props: IToggleIconStyle) =>
      props.disabled &&
      (props?.disabledColor ? `${props.disabledColor}!important` : 'rgba(255, 255, 255, 0.45)!important')};
  }
`;
